import { BoardStore } from "@noli/business";
import { useEffect } from "react";
import { statusStore } from "@/stores/status";
import useImageWithPlaceholder from "@/modules/editor/hooks/useImageWithPlaceholder";

import { runInAction } from "mobx";
import { getPreviewSrc } from "@/utils/misc";
import { Editor_Words } from "@/utils/lang/editor";

export function useInpaintingMask() {
  const { inpaintingMaskAlias } = statusStore;

  const {
    alias,
    enable: valid,
    placeholder,
  } = useImageWithPlaceholder({
    type: "path",
    placeholderConfig: {
      noneSelect: Editor_Words["select-a-path"],
      notTargetType: Editor_Words["current-select-not-path"],
    },
  });
  const inpaintingMaskNode = inpaintingMaskAlias
    ? BoardStore.graph.getExistingNode(inpaintingMaskAlias)
    : null;

  useEffect(() => {
    console.log("valid: ", valid);
    if (valid) {
      setAsInpaintingMask(alias);
    }
  }, [alias]);

  useEffect(() => {
    if (!valid) {
      // 当前选中标记节点被删了
      if (inpaintingMaskAlias && !getPreviewSrc(inpaintingMaskAlias)) {
        setAsInpaintingMask("");
      }
    }
  }, [valid]);

  function setAsInpaintingMask(alias: string): void {
    runInAction(() => {
      statusStore.inpaintingMaskAlias = alias;
    });
  }

  return {
    maskNode: inpaintingMaskNode,
    maskPlaceHolder: placeholder,
  };
}
